"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultKonfektionierungArtNr = void 0;
exports.defaultKonfektionierungArtNr = 'KONFEKTIONIERUNG';
//# sourceMappingURL=KonfektionierungModel.js.map